import React from "react";
import {
  CardContent,
  Typography,
  SxProps,
  Theme,
  Card,
  Box,
} from "@mui/material";
import { handleIfLimitCharacter } from "src/shared/Utils/LimitText";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ButtonCore } from "../ButtonCore/ButtonCore";

interface CardLandingPageProps {
  landingPageComponent: React.ReactNode;
  title: string;
  icon?: React.ReactNode; // Ícone opcional, pode ser um <Avatar> ou <Icon>
  sx?: SxProps<Theme>; // Permite estilização adicional do Card
  id: string;
}

export const CardLandingPage: React.FC<CardLandingPageProps> = ({
  landingPageComponent,
  title,
  id,
  sx = {},
}) => {
  const { userPerfil } = useAuthContext();

  const handleCopyLink = (id: string) => {
    const domain = window.location.origin;

    const link = `${domain}/landing-page/${id}/${userPerfil?.idTenant}`;
    navigator.clipboard.writeText(link);
  };

  const handlePreview = (id: string) => {
    const domain = window.location.origin;

    const link = `${domain}/landing-page/${id}/${userPerfil?.idTenant}`;
    window.open(link, "_blank");
  };

  return (
    <Card
      sx={{
        borderRadius: "8px",
        maxHeight: "245px",
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >
      <Box sx={{ height: "165px", overflow: "hidden" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Box sx={{ width: "200%", height: "200%", position: "relative" }}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                transform: "scale(0.5)",
                transformOrigin: "top left",
                width: "100%",
                height: "100%",
                pointerEvents: "none",
              }}
            >
              {landingPageComponent}
            </Box>
          </Box>
        </Box>
      </Box>

      <CardContent
        sx={{ pt: 1.5, pb: "12px !important", borderTop: "2px solid #E0E0E0" }}
      >
        <Box sx={{ mb: 1.5 }}>
          <Typography
            variant="subtitle1"
            component="div"
            color="text.primary"
            sx={{
              fontWeight: "medium",
              lineHeight: 1.4,
              fontSize: { xs: 12, md: 15 },
            }}
          >
            {handleIfLimitCharacter({
              value: title,
              LIMIT: 28,
            })}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}>
          <ButtonCore
            title="Copiar link"
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleCopyLink(id)}
          />
          <ButtonCore
            title="Visualizar"
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handlePreview(id)}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
